import Typography from "@mui/material/Typography";

const DescriptionEquipment = ({
  command,
  handleInputChange,
  handleApply,
}) => {
  return (
    <div style={{ flex: 1, paddingLeft: "1rem", borderLeft: "1px solid #ddd" }}>
      <Typography variant="body2">
        <strong style={{ color: "#979797" }}>Description:</strong>
      </Typography>
      <Typography style={{ color: "#caaf66", fontSize: "18px" }}>
        {command.description}
      </Typography>

      {command.inputTypeCommandId === 2 && (
        <InputGroup
          inputs={[
            { placeholder: "pon", value: command.pon, name: "pon" },
            { placeholder: "port", value: command.port, name: "port" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 1 && (
        <InputGroup
          inputs={[{ placeholder: "pon", value: command.pon, name: "pon" }]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 7 && (
        <InputGroup
          inputs={[
            { placeholder: "vlanId", value: command.vlanId, name: "vlanId" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 3 && (
        <InputGroup
          inputs={[{ placeholder: "mac", value: command.mac, name: "mac" }]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 4 && (
        <InputGroup
          inputs={[{ placeholder: "macCisco", value: command.macCisco, name: "macCisco" }]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 6 && (
        <InputGroup
          inputs={[{ placeholder: "port", value: command.port, name: "port" }]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 8 && (
        <InputGroup
          inputs={[{ placeholder: "sn", value: command.sn, name: "sn" }]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 9 && (
        <InputGroup
          inputs={[
            { placeholder: "pon", value: command.pon, name: "pon" },
            { placeholder: "port", value: command.port, name: "port" },
            { placeholder: "comment", value: command.comment, name: "comment" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 10 && (
        <InputGroup
          inputs={[
            { placeholder: "pon", value: command.pon, name: "pon" },
            { placeholder: "sn", value: command.sn, name: "sn" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

     {command.inputTypeCommandId === 12 && (
        <InputGroup
          inputs={[
            { placeholder: "pon", value: command.pon, name: "pon" },
            { placeholder: "port", value: command.port, name: "port" },
            { placeholder: "vlanId", value: command.vlanId, name: "vlanId" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 13 && (
        <InputGroup
          inputs={[
            { placeholder: "pon", value: command.pon, name: "pon" },
            { placeholder: "macCisco", value: command.macCisco, name: "macCisco" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 14 && (
        <InputGroup
          inputs={[
            { placeholder: "pon", value: command.pon, name: "pon" },
            { placeholder: "port", value: command.port, name: "port" },
            { placeholder: "macCisco", value: command.macCisco, name: "macCisco" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 15 && (
        <InputGroup
          inputs={[
            { placeholder: "ip", value: command.ip, name: "ip" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 16 && (
        <InputGroup
          inputs={[
            { placeholder: "ip", value: command.ip, name: "ip" },
            { placeholder: "port", value: command.port, name: "port" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

      {command.inputTypeCommandId === 17 && (
        <InputGroup
          inputs={[
            { placeholder: "ipHost", value: command.ipHost, name: "ipHost" },
            { placeholder: "gateway", value: command.gateway, name: "gateway" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}

        {command.inputTypeCommandId === 18 && (
        <InputGroup
          inputs={[
            { placeholder: "pon", value: command.pon, name: "pon" },
            { placeholder: "port", value: command.port, name: "port" },
            { placeholder: "sn", value: command.vlanId, name: "sn" },
          ]}
          handleInputChange={(name, value) =>
            handleInputChange(command.id, name, value)
          }
          handleApply={() => handleApply(command.id)}
        />
      )}
    </div>
  );
};

const InputGroup = ({ inputs, handleInputChange, handleApply }) => (
  <div
    style={{
      marginTop: "1rem",
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    {inputs.map((input, index) => (
  <input
    key={index}
    type={input.type || "text"}
    placeholder={input.placeholder}
    value={input.value}
    onChange={(e) => {
      const value = e.target.value;
      if (input.name === "macCisco") {
        const cleaned = value.replace(/[^a-fA-F0-9]/g, "");
        const formatted = cleaned
          .match(/.{1,4}/g) 
          ?.join(".") 
          .toLowerCase(); 
        handleInputChange(input.name, formatted || ""); 
      } else {
        handleInputChange(input.name, value);
      }
    }}
    style={{
      width:
        input.name === "comment" ||
        input.name === "sn" ||
        input.name === "mac" ||
        input.name === "macCisco" ||
        input.name === "ip" ||
        input.name === "ipHost" ||
        input.name === "gateway"
          ? "150px"
          : "70px",
      padding: "5px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      backgroundColor: "#3b3b3b",
      color: "#fff",
    }}
  />
))}
<button
  style={{
    padding: "5px 10px",
    backgroundColor: "#e09900",
    border: "none",
    borderRadius: "4px",
    color: "black",
    cursor: "pointer",
  }}
  onClick={handleApply}
>
  Применить
</button>
  </div>
);

export default DescriptionEquipment;